import { render, staticRenderFns } from "./FeaturesSection.vue?vue&type=template&id=2111fa80&scoped=true"
import script from "./FeaturesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturesSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2111fa80",
  null
  
)

export default component.exports